import { useParams } from "react-router";

const useTokenNavigate = () => {
  const { token } = useParams();

  const handleTokenNavigate = (path: string) => {
    return `/${token}${path}`;
  };

  return { token, handleTokenNavigate };
};

export default useTokenNavigate;
